import { createContext } from 'react';

export const AppLoadContext = createContext()
